/** SAR tarzı 3 ondalık gösterim */
export function formatRate(value: number): string {
  if (!Number.isFinite(value)) return '—'
  return value.toFixed(3)
}
